import {
  Question,
  QuestionFormResponse,
} from '../../questionnaire/types/questionnaire.types';

export const formatResponse = (
  question: Question,
  response: QuestionFormResponse
): string => {
  if (!response) return 'Não respondida';

  switch (question.type) {
    case 'multiple_choice':
      if (response.questionType === 'multiple_choice') {
        return response.response.answerText;
      }
      break;

    case 'true_false':
      if (response.questionType === 'true_false') {
        return response.response.value ? 'SIM' : 'NÃO';
      }
      break;

    case 'essay':
      if (response.questionType === 'essay') {
        return response.response.text || 'Sem resposta';
      }
      break;

    case 'multiple_choice_checkbox':
      if (response.questionType === 'multiple_choice_checkbox') {
        return response.response.answers.map((a) => a.answerText).join(', ');
      }
      break;

    case 'matrix_scale':
      if (response.questionType === 'matrix_scale') {
        return response.response.matrixAnswers
          .map((m) => `${m.rowText}: ${m.answerText}`)
          .join('\n');
      }
      break;

    case 'ranking':
      if (response.questionType === 'ranking') {
        const sortedAnswers = [...response.response.rankedAnswers].sort(
          (a, b) => a.rank - b.rank
        );
        return sortedAnswers
          .map((a) => `${a.rank}º - ${a.answerText}`)
          .join('\n');
      }
      break;

    default:
      return 'Formato desconhecido';
  }

  return 'Não respondida';
};

export const getResponseColor = (hasResponse: boolean): string => {
  return hasResponse ? '#7854AB' : '#9ca3af';
};
